// extracted by mini-css-extract-plugin
module.exports =  {"button":"DD4Xz1n","trigger":"RNkwTbK","open":"A66z99x","outlined":"JuqjdWO","disabled":"lOih1cT"};